import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { List, ListItem as MuiListItem, ListItemText, ListItemIcon } from "@mui/material";
import { styled } from "@mui/material/styles";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";

import { navItems } from "./constants";
import { TEST_CASE_GENERATION_URL } from "../../Config/Config";
import { AutoFixHighOutlined } from "@mui/icons-material";

const StyledListItem = styled(MuiListItem)(({ theme, active }) => ({
  color: "#8C9EB8",
  columnGap: "15px",
  marginBottom: "25px",
  "& .MuiTypography-root": {
    fontSize: "14px",
  },
  "& .MuiListItemText-root": {
    fontSize: "14px",
  },
  "&:hover": {
    backgroundColor: "#FF5336",
    borderRadius: "8px",
    color: "#242f3f",
    "& .MuiListItemIcon-root": {
      color: "#ffffff",
    },
    "& .MuiListItemText-root": {
      color: "#ffffff",
    },
  },
  "& .MuiListItemIcon-root": {
    color: "#8C9EB8",
    minWidth: "unset",
  },
  ...(active && {
    backgroundColor: "#FF5336",
    color: "#ffffff",
    borderRadius: "8px",
    "& .MuiListItemIcon-root": {
      color: "#ffffff",
      minWidth: "unset",
    },
    "& .MuiListItemText-root": {
      color: "#ffffff",
    },
  }),
}));

const Sidebar = () => {
  const location = useLocation();

  const handleTestCaseGeneration = () => {
    const userDetails = localStorage.getItem("userDetail");
    const user = JSON.parse(userDetails);
    const logoUrl = user.company?.brandLogo;
    const url = new URL(logoUrl);
    const fileName = url.searchParams.get("fileName");
    window.open(
      `${TEST_CASE_GENERATION_URL}?state=${user.token}&companyId=${user.companyid}&clgo=${fileName}`,
      "_blank",
    );
  };

  return (
    <>
      <List sx={{ flex: "1" }}>
        {navItems.map((item) => {
          const isActive =
            location.pathname === item.path ||
            (location.pathname === "/new" && item.text === "Dashboard") ||
            location.pathname === item.path ||
            location.pathname === `${item.path}/history`;
          return (
            <StyledListItem
              key={item.text}
              component={NavLink}
              to={item.path}
              active={isActive ? 1 : 0}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </StyledListItem>
          );
        })}

        <StyledListItem onClick={handleTestCaseGeneration} sx={{ cursor: "pointer" }}>
          <ListItemIcon>
            <AutoFixHighOutlined />
          </ListItemIcon>
          <ListItemText primary={"GenAI Testing"} />
        </StyledListItem>
      </List>

      <List>
        <StyledListItem sx={{ marginBottom: 0 }} 
        component={NavLink}
        to={"/new/settings"}
        active={location.pathname === "/new/settings" ? 1 : 0}
        >
          <ListItemIcon>
            <SettingsOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary={"Settings"} />
        </StyledListItem>
      </List>
    </>
  );
};

export default Sidebar;
